import React, { useEffect, useState } from "react";
import InputCommon from "components/inputCommon";
import { RootStateOrAny, useSelector } from "react-redux";
import { BeatLoader } from "react-spinners";
import * as Styles from "../../styles";
import { AuthState } from "../../../../store/ducks/auth/types";
import ComboBoxCommon from "../../../comboBoxCommon";
import { useAlterarEmails } from "../../../../services/api/AppWeb_Lead/alterar-emails";

interface Props {
  closeModal: Function;
  email1: string | null;
  email2: string | null;
  email3: string | null;
  emailPrincipal: number | null | undefined;
  idLead: string | undefined | any;
  idLeadCorretor: string | undefined | any;
  emailOrigemInformado: boolean | undefined;
}

const LeadEmailModal = (props: Props) => {
  const { codigoCargo2013 } = useSelector<RootStateOrAny, AuthState>(
    (state) => state.user
  );
  const isCorretor =
    codigoCargo2013 === "219.840.002" ||
    codigoCargo2013 === "219.840.012" ||
    codigoCargo2013 === "219.840.001";
  const [email1, setEmail1] = useState(props?.email1 ? props.email1 : "");
  const [email2, setEmail2] = useState(props?.email2 ? props.email2 : "");
  const [email3, setEmail3] = useState(props?.email3 ? props.email3 : "");
  const [emailPrincipal, setEmailPrincipal] = useState(
    props?.emailPrincipal ? props.emailPrincipal : 1
  );

  const { mutate, isLoading, isSuccess } = useAlterarEmails({
    idLeadCorretor:
      props?.idLeadCorretor === undefined ? "" : props?.idLeadCorretor,
    body: {
      idLead: props?.idLead === undefined ? "" : props?.idLead,
      emails: [
        {
          email: email1,
          emailPrincipal: emailPrincipal === 1,
          codigoCampoEmail: 1,
        },
        {
          email: email2,
          emailPrincipal: emailPrincipal === 2,
          codigoCampoEmail: 2,
        },
        {
          email: email3,
          emailPrincipal: emailPrincipal === 3,
          codigoCampoEmail: 3,
        },
      ],
    },
  });

  useEffect(() => {
    if (isSuccess) {
      props?.closeModal();
    }
  }, [isSuccess]);

  return (
    <>
      <Styles.ContentModal>
        <Styles.InfoModal style={{ marginBottom: 8 }}>
          O corretor pode <span>alterar e adicionar</span> até 3 emails de
          contato, além de definir qual é o <span>email principal</span>!
        </Styles.InfoModal>
        <Styles.Text style={{ margin: "0" }}>Email 1</Styles.Text>
        <InputCommon
          isError={false}
          type="text"
          isDisabled={
            props?.emailOrigemInformado ? props?.emailOrigemInformado : false
          }
          placeholder="Email de origem"
          helperText=""
          value={email1}
          onChange={(event: string) => {
            setEmail1(event);
          }}
        />
        {isCorretor ? (
          <ComboBoxCommon
            value={1}
            valueSelected={emailPrincipal}
            onValueSelected={(val) => setEmailPrincipal(val)}
            text="Email principal"
          />
        ) : null}

        <Styles.Text style={{ margin: "8px 0 0 0" }}>Email 2</Styles.Text>
        <InputCommon
          isDisabled={!isCorretor}
          isError={false}
          type="text"
          placeholder="Email 2"
          helperText=""
          value={email2}
          onChange={(event: string) => {
            setEmail2(event);
          }}
        />
        {isCorretor ? (
          <ComboBoxCommon
            value={2}
            valueSelected={emailPrincipal}
            onValueSelected={(val) => setEmailPrincipal(val)}
            text="Email principal"
          />
        ) : null}
        <Styles.Text style={{ margin: "8px 0 0 0" }}>Email 3</Styles.Text>
        <InputCommon
          isDisabled={!isCorretor}
          isError={false}
          type="text"
          placeholder="Email 3"
          helperText=""
          value={email3}
          onChange={(event: string) => {
            setEmail3(event);
          }}
        />
        {isCorretor ? (
          <ComboBoxCommon
            value={3}
            valueSelected={emailPrincipal}
            onValueSelected={(val) => setEmailPrincipal(val)}
            text="Email principal"
          />
        ) : null}
      </Styles.ContentModal>
      <Styles.Footer>
        <Styles.FooterDialog>
          <Styles.Button
            style={{ width: "100%" }}
            variant="outlined"
            onClick={() => {
              props.closeModal();
            }}
          >
            Fechar
          </Styles.Button>
          {isCorretor ? (
            <Styles.SaveButton
              style={{
                width: "100%",
                background: "#4a76fb",
                boxShadow: "none",
                color: "#fff !important",
              }}
              onClick={() => {
                mutate();
              }}
            >
              {isLoading ? <BeatLoader color="#fff" size={10} /> : "Salvar"}
            </Styles.SaveButton>
          ) : null}
        </Styles.FooterDialog>
      </Styles.Footer>
    </>
  );
};

export default LeadEmailModal;
